module.exports = __webpack_public_path__ + "img/icon_shot1.e5c17b4c.png";